var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"font-weight-regular",attrs:{"title":_vm.$t('tenants.upgrade_plan'),"to":{ name: 'tenant_settings' },"color":"warning","link":"","target":"_blank","x-small":""}},[_vm._v(_vm._s(_vm._plan)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }